<template>
    <nav id="site-navbar" class="navbar navbar-expand-lg fixed-top navbar-dark bg-danger">
        <div class="container">
            <button ref="collapseButton" class="navbar-toggler" type="button" data-toggle="collapse" data-target="#navbarText" aria-controls="navbarText" aria-expanded="false" aria-label="Toggle navigation">
                <span class="navbar-toggler-icon"></span>
            </button>
            <a class="navbar-brand" :href="homeLink">
                <img id="navbar-brand-image" :src="headerImage" class="__white_logo" alt="main-logo-white" height="50px">
            </a>
            <div ref="navbarCollapse" class="collapse navbar-collapse" id="navbarText">
                <ul class="navbar-nav mr-auto">
                    <router-link v-for="(link, key) in links" :key="key" :to="link" v-slot="{ href, route, navigate, isExactActive }">
                        <li :class="[isExactActive && 'active', 'nav-item']" >
                            <a :href="href" class="nav-link" @click="navigate">{{ route.name }}</a>
                        </li>
                    </router-link>
                </ul>
                
                <router-link v-if="!isLoggedIn" to="/book-now" v-slot="{ href, navigate }">
                    <a :href="href" @click="navigate" class="btn btn-warning">
                        Book now
                    </a>
                </router-link>
            </div>
            <div v-if="isLoggedIn" class="navbar-header">
                <ul class="nav navbar-nav user-nav">
                    <li class="nav-item hide-on-small" style="height: 28.5px;">
                        <router-link to="/bookings/create" v-slot="{ href, navigate }">
                            <a class="btn btn-warning" style="margin-top: -6px;" :href="href" @click="navigate">Book now</a>
                        </router-link>
                    </li>
                    <!-- <li is="notification-badge" class="nav-item dropdown"></li> -->
                    <!-- <notification-badge /> -->
                    <li class="nav-item" style="height: 28.5px;">
                        <router-link to="/user/profile" v-slot="{ href, navigate }">
                            <a class="nav-link" :href="href" @click="navigate" v-text="authenticatedUser.name"></a>
                        </router-link>
                    </li>
                    <li class="nav-item dropdown" style="height: 28.5px;">
                        <a class="nav-link" href="#" id="navbar-dropdown-menu" role="button" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                            <i class="fas fa-caret-down"></i>
                        </a>
                        <div class="dropdown-menu dropdown-menu-right" aria-labelledby="navbar-dropdown-menu">
                            <router-link to="/bookings/create" v-slot="{ href, navigate }">
                                <a class="dropdown-item show-on-small" :href="href" @click="navigate">Book now</a>
                            </router-link>
                            <router-link v-for="(link, key) in userLinks" :key="key" :to="link" v-slot="{ href, route, navigate }">
                                <a class="dropdown-item" :href="href" @click="navigate" v-text="route.name"></a>
                            </router-link>
                            <div class="dropdown-divider"></div>
                            <a class="dropdown-item" :href="logoutLink">Log out</a>
                        </div>
                    </li>
                </ul>
            </div>
        </div>
    </nav>
</template>
<script>
import { resource, pageRoute } from "@utils/network";
import NotificationBadge from "../../partials/NotificationBadge";
import store from "@store";

export default {
    name: "GuestHeader",
    store,
    components: { NotificationBadge },

    computed: {
        authenticatedUser() {
            return this.$store.getters.authenticatedUser || {};
        },
        isLoggedIn() {
            return this.authenticatedUser && this.authenticatedUser.id;
        },
    },

    data: () => ({
        logoutLink: pageRoute('logout'),
        headerImage: resource('images/logo-white.png'),
        links: [
            "/",
            "/about-us",
            "/partners",
            "/how-it-works",
            "/faqs",
            "/contact-us",
        ],
        homeLink: pageRoute(""),
        userLinks: [
            "/user/bookings",
            "/user/addresses",
            "/user/favorite-shops",
            "/user/vouchers",
        ]
    }),

    methods: {
        isNavbarCollapseShowing() {
            return this.$refs.navbarCollapse
                && this.$refs.navbarCollapse.classList.contains("show");
        },
    },

    watch: {
        // authenticatedUser(newValue, oldValue) {
        //     if ((oldValue === null || oldValue === undefined || oldValue.id == null) && newValue.id != null) {
        //         this.initializeUser();
        //     }
        // },
    },

    mounted() {
        $(document).click((event) => {
            if (!$(event.target).hasClass("navbar-toggler")) {
                if (!this.$refs.navbarCollapse) return;
                this.$refs.navbarCollapse.classList.remove("show")
            }
        });
    }
}
</script>
<style scoped>
.user-nav.navbar-nav{
    flex-direction: row;
}
.user-nav .nav-link {
    padding-right: 1rem;
    padding-left: 1rem;
    color: white !important;
}
.user-nav .dropdown-menu {
    position: absolute;
    top: 100%;
    right: 0;
    z-index: 1000;
    float: left;
    min-width: 10rem;
}
.user-nav .nav-link:hover {
    color: rgba(255, 255, 255, 0.65)  !important;
}
</style>